import { useEffect } from "react";

/**
 * Inject a schema.org JSON-LD block into <head> for AI + search discoverability.
 * The `id` lets the same page swap schemas cleanly without duplication.
 */
export default function JsonLd({ id, data }) {
  useEffect(() => {
    if (!data) return undefined;
    const el = document.createElement("script");
    el.type = "application/ld+json";
    if (id) el.setAttribute("data-jsonld-id", id);
    el.text = JSON.stringify(data);
    document.head.appendChild(el);
    return () => {
      if (el.parentNode) el.parentNode.removeChild(el);
    };
  }, [id, data]);

  return null;
}
